import { Button } from "antd";
import { DiamondWhite } from "@/assets/icons";

type Props = {
  mode: "dual" | "confirm";
  onAccept?: () => void;
  onDecline?: () => void;
  onConfirm?: () => void;
  loadingPurpose?: "ACCEPTED" | "DECLINED" | null;
  acceptLabel?: string;
  declineLabel?: string;
  confirmLabel?: string;
  blockOnMobile?: boolean;
};

export default function ActivityActionButtons({
  mode,
  onAccept,
  onDecline,
  onConfirm,
  loadingPurpose,
  acceptLabel = "Accept",
  declineLabel = "Decline",
  confirmLabel = "Yes, Connect",
  blockOnMobile = false,
}: Props) {
  if (mode === "confirm") {
    return (
      <Button
        block={blockOnMobile}
        type="primary"
        size="middle"
        aria-label={confirmLabel}
        loading={loadingPurpose === "ACCEPTED"}
        onClick={onConfirm}
      >
        {confirmLabel} <DiamondWhite className="ml-2" />
      </Button>
    );
  }

  return (
    <div className="flex gap-4 items-center">
      <Button
        className="flex-1"
        type="primary"
        size="middle"
        aria-label={acceptLabel}
        loading={loadingPurpose === "ACCEPTED"}
        onClick={onAccept}
      >
        {acceptLabel} <DiamondWhite className="ml-2" />
      </Button>
      <Button
        className="flex-1"
        size="middle"
        aria-label={declineLabel}
        loading={loadingPurpose === "DECLINED"}
        onClick={onDecline}
      >
        {declineLabel}
      </Button>
    </div>
  );
}

